import React, {PropTypes} from 'react';
import books from './img/page1_pic7.jpg';
import Image from 'react-bootstrap/lib/Image';
import renderHTML from 'react-render-html';

class Intro extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  };
  render() {
    return (
        <section className="bookBox">
          <div className="container">
            <div className="row">
              <article className="col-lg-12 col-md-12 col-sm-12">
                <figure><Image src={books} alt="books"/></figure>
                <div className="extra-wrap">
                  <p className="title">{this.props.title}</p>
                  <p>
                    {renderHTML(this.props.text)}
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>);
  }
}

  export default Intro;


// WEBPACK FOOTER //
// ./src/Intro.js